import aggiungi from  './aggiungi'
import estrattoConto from './estratto-conto'

export default [
  // always
  {
    'key': 'fornitori-button-aggiungi',
    'label': 'AGGIUNGI FORNITURA',
    'classCss': 'p-button-secondary',
    'icon': 'pi pi-plus',
    'type': 'operation',
    'method': aggiungi,
    'display': 'always'
  },

  // on-data-filtered
  {
    'key': 'fornitori-button-estratto-conto',
    'label': 'ESTRATTO CONTO',
    'classCss': 'p-button-secondary',
    'icon': ' pi pi-directions',
    'type': 'operation',
    'method': estrattoConto,
    'display': 'on-data-filtered'
  },
]
